import { runInAction } from 'mobx'

import { storage } from 'utils'

import BaseStore from './BaseStore'

let state
export class Lang extends BaseStore {
  constructor() {
    super()
    this.observable({
      selected: 'eng',
    })

    state = this
  }

  async init() {
    const temp = await storage.load('language')
    if (temp) {
      const { lang = 'eng' } = temp
      this.setLanguage(lang)
    }
  }

  setLanguage(val) {
    const lang = val === 'thai' ? 'thai' : 'eng'
    // storage.save('language', { lang })

    runInAction(() => {
      state.selected = lang
    })
  }

  isThai() {
    return this.selected === 'thai'
  }

  getMessage(eng, thai) {
    let text = this.selected === 'thai' ? thai : eng
    if (text === '' || text === undefined) {
      return eng
    }

    return text
  }

  getTxtSuccess() {
    const text =
      this.selected === 'thai' ? 'บันทึกเรียบร้อยแล้ว' : 'saved successfully'

    return text
  }

  getValidate(invalid, text, text_th) {
    if (invalid) {
      const txt =
        this.selected === 'thai' ? `กรุณากรอก${text_th}` : `please fill ${text}`

      return txt
    }

    return undefined
  }

  getFullValidate(invalid, text, text_th) {
    if (invalid) {
      const txt = this.selected === 'thai' ? text_th : text

      return txt
    }

    return undefined
  }
}

export default new Lang()
